/**
 * Cardholder name input. Renders the F&P-styled label + `<input>` outside
 * the Adyen iframe (PCI scope reduced because no card data ever touches it).
 */

import React, { useId } from 'react';
import { Box, Typography } from '@mui/material';

import { UI_CONFIG } from '../../utils/constants';

export interface HolderNameInputProps {
  value: string;
  onChange: (value: string) => void;
  disabled?: boolean;
}

const HolderNameInput: React.FC<HolderNameInputProps> = ({ value, onChange, disabled }) => {
  const id = useId();
  return (
    <Box className="input-gap" sx={{ display: 'flex', flexDirection: 'column', gap: 0.5 }}>
      <Typography component="label" htmlFor={id} sx={{ color: UI_CONFIG.TEXT_COLOR }}>
        Cardholder Name
      </Typography>
      <input
        id={id}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        disabled={disabled}
        autoFocus
        className="adyen-checkout__card__holderName__input adyen-checkout__input"
        type="text"
        name="cardName"
        autoComplete="cc-name"
      />
    </Box>
  );
};

export default HolderNameInput;
